import {UserAlertsError} from './UserAlertsError.js'

export class MaxLimitReachedUserAlertError extends UserAlertsError {
  constructor({code, message}) {
    super({code, message})
    this._code = code
    this._message = message
  }

  getError = () => {
    return {
      message: this._message,
      code: this._code
    }
  }
}
